import type { IconSvgObject } from './types';

const Table01Icon: IconSvgObject = [
  ["path", { d: "M4 10C4 10 1.5 11.6556 2.5 14.5C3.5 17.3444 2.625 19.4074 2 20M4 10V4M4 10H20M4 4H2M4 4H20M20 10C20 10 22.5 11.6556 21.5 14.5C20.5 17.3444 21.375 19.4074 22 20M20 10V4M20 4H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.5 7H13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Table01Icon;
